import {
  FeedbackItemType,
  FeedbackReplyStatus,
} from "@/components/HeaderFeedback/types";
import { Button, Tag } from "antd";
import { RightOutlined } from "@ant-design/icons";

interface FeedbackItemProps {
  data: FeedbackItemType;
}
const FeedbackItem = ({ data }: FeedbackItemProps) => {
  return (
    <div className="bg-white w-full pl-3 rounded cursor-pointer">
      <div className="flex flex-row items-center justify-between">
        <span className="font-medium text-[#333333]">{data.classifyName}</span>
        {data.handleStatus === FeedbackReplyStatus.REPLIED ? (
          <Tag color="error">已回复</Tag>
        ) : (
          <Tag color="processing">待回复</Tag>
        )}
      </div>
      <div className="text-sm text-[#666666] my-2 mr-3 leading-6 line-clamp-1">
        {data.content}
      </div>
      <div className="flex flex-row items-center justify-between">
        <span className="text-xs text-[#999999]">
          反馈时间：{data.createdAt}
        </span>
        <Button
          type="primary"
          size="small"
          ghost={true}
          className="border-none"
        >
          查看详情
          <RightOutlined style={{ marginLeft: 0 }} />
        </Button>
      </div>
    </div>
  );
};

export default FeedbackItem;
